var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoles(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1573 9.99377C14.1573 14.1577 11.2426 16.2396 7.77818 17.4472C7.59677 17.5087 7.39971 17.5057 7.22021 17.4389C3.74751 16.2396 0.832764 14.1577 0.832764 9.99377V4.16429C0.832764 3.94342 0.920503 3.7316 1.07668 3.57542C1.23286 3.41924 1.44468 3.3315 1.66555 3.3315C3.33111 3.3315 5.41307 2.33216 6.86211 1.06633C7.03854 0.915598 7.26298 0.832779 7.49503 0.832779C7.72708 0.832779 7.95152 0.915598 8.12795 1.06633C9.58532 2.34049 11.6589 3.3315 13.3245 3.3315C13.5454 3.3315 13.7572 3.41924 13.9134 3.57542C14.0696 3.7316 14.1573 3.94342 14.1573 4.16429V9.99377Z",
    stroke: "black",
    strokeWidth: 1.66557,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoles);
export default __webpack_public_path__ + "static/media/roles.1765f09a7082eb010ce7c9543bf12bbc.svg";
export { ForwardRef as ReactComponent };